import { createLogger, type LogEvent, type LoggerHook, type LogLevel } from 'vue-logger-plugin'
const isProduction = import.meta.env.VITE_ISPROD === 'true'
const isLogEnabled = import.meta.env.VITE_LOGGER === 'true'

//console.log('isProduction', isProduction)
//console.log('isLogEnabled', isLogEnabled)
const logLevel: LogLevel = isProduction ? 'info' : 'debug'
//console.log('LogLevel', logLevel)

export function j ( ...x: any[] ): string {
  return safeToStringLocal( x.length > 1 ? x : x[ 0 ] )
}

const StringifyLogHook: LoggerHook = {
  run ( event: LogEvent ) {
    j( event )
  },
  // example using async/await:
  // async run(event: LogEvent) {
  //   await axios.post('/log', { severity: event.level, data: event.argumentArray })
  // }
}

// create logger with options
const loggerLocal = createLogger( {
  enabled: isLogEnabled,
  level: logLevel,
  callerInfo: true,
  //beforeHooks: [ ... ],
  //afterHooks: [ ... ]
  //beforeHooks: [StringifyObjectsHook],
  beforeHooks: [ StringifyLogHook ],
  prefixFormat: ( { level, caller } ) =>
    caller
      ? `[${ level.toUpperCase() }] [${ caller?.fileName }<${ caller?.functionName }>:${ caller?.lineNumber }]=>`
      : `[${ level.toUpperCase() }]=>`,
} )

export function safeToStringLocal ( value: unknown ) {
  if ( typeof value === 'string' )
  {
    return value
  }

  try
  {
    return JSON.stringify( value )
  } catch
  {
    return String( value )
  }
}

export default loggerLocal
